import { Message } from '@cpd-app/generated';
import { ChatRole } from '../models/ai-chat';

import { ChatMessage } from '../models/ai-chat/chat-message';
import { ConversationGoalsMapper } from './conversation-goals.mapper';

export class MessageMapper {
  static toChatMessage(message: Message): ChatMessage {
    return {
      ...message,
      role: message.role as ChatRole,
      createdAt: new Date(+message.createdAt).toISOString(),
      liked: message.liked,
      disliked: message.disliked,
      goals: ConversationGoalsMapper.toConversationGoals(
        message.metadata?.conversationGoals
      ),
      courses: message.metadata?.learningSuggestions?.courses,
      certificates: message.metadata?.learningSuggestions?.certificates
    };
  }
}
